// ============================================================================
// French UI Copy — FULL SSOT (1:1 translation of en.ts)
// Texte uniquement — PAS de logique, PAS d’URLs, PAS de React
// ============================================================================

export const fr = {
  meta: {
    lang: 'fr',
    langFull: 'fr-FR',
    dir: 'ltr' as const,
    name: 'Français',
  },

  // ─────────────────────────────────────────────────────────────
  // WORDS
  // ─────────────────────────────────────────────────────────────

  words: {
    dj: {
      he: `DJ`,
      he_alt: `DJ`,
      he_plain: `DJ`,
      en: `DJ`,
    },
    music: 'Musique',

    mc: `DJ`,

    events: {
      wedding: { one: `Mariage`, many: `Mariages`, to: `pour un mariage` },
      henna: { one: `Henné`, many: `Henné`, to: `pour un henné` },
      bar_bat: {
        one: `Bar/Bat Mitsva`,
        many: `Bar/Bat Mitsvas`,
        to: `pour une Bar/Bat Mitsva`,
      },
      generic: { one: `Événement`, many: `Événements`, to: `pour un événement` },
    },

    albums: {
      forum: `Forum`,
      articles: `Articles`,
      recommendations: `Avis`,
      bars: `Bars`,
      flyers: `Flyers`,
    },

    phrases: {
      music_for_events: `musique pour événements`,
      company_or_private: `entreprise / privé`,
    },
  },

  business: {
    name: 'DJ ELIOR MOR — Musique pour événements',

    address: {
      street: 'Mivtsa Yoav 16',
      city: 'Be’er Sheva',
      postal: '8445914',
      country: 'IL',
    },
  },

  // ─────────────────────────────────────────────────────────────
  // BRAND
  // ─────────────────────────────────────────────────────────────
  brand: {
    firstName: `ELIOR`,
    short: `ELIOR MOR`,
    title: `DJ ELIOR MOR`,
  },

  metaDescription: {
    wedding:
      'Plus de 15 ans d’expérience en mariages : bande-son personnalisée, excellente lecture du public, mix précis et fusion de styles, piste de danse pleine toute la nuit — DJ mariage professionnel',

    henna:
      'Plus de 15 ans d’expérience en henné : tradition mêlée à des rythmes modernes, ambiance colorée et piste de danse pleine — DJ henné professionnel',

    barBat:
      'Plus de 15 ans d’expérience en Bar/Bat Mitsva : entrée émouvante, musique pour adolescents et adultes, piste pleine du début à la fin — DJ professionnel',

    generic:
      'Plus de 15 ans d’expérience événementielle : planification musicale, lecture du public et fusion des styles, piste de danse pleine toute la soirée — DJ événement professionnel',
  },

  // ─────────────────────────────────────────────────────────────
  // HOME
  // ─────────────────────────────────────────────────────────────

  home: {
    title: `Musique pour événements | DJ ELIOR MOR`,

    description:
      `ELIOR MOR — DJ avec plus de 15 ans d’expérience dans les mariages, cérémonies de henné, Bar/Bat Mitsvas et événements. ` +
      `Expert en lecture du public, fusion des styles et mix fluides qui maintiennent la piste de danse pleine et créent une expérience musicale inoubliable`,

    heroTitle: `ELIOR MOR — Musique pour événements`,

    sections: {
      section1Lines: (
        eventOne: string,
        mcLabel: string,
        brandTitle: string
      ) => [
        `Plus de 15 ans à créer des ${eventOne}s parfaits`,
        'Musique précise et excellente lecture du public',
        'Son professionnel et mix fluides',
        `${eventOne} avec une ambiance joyeuse et énergique`,
        `Playlist adaptée exactement à votre ${eventOne}`,
        'Une expérience musicale inoubliable',
        `${brandTitle} — ${mcLabel} pour le ${eventOne} parfait`,
      ],

      section2DescriptionSuffix: (eventOne: string) =>
        `pour que chaque ${eventOne} devienne une expérience inoubliable dont les invités parleront longtemps après la fin`,

      section2AdditionalSuffix: '',

      section5SubtitleDesktop: (
        weddingOne: string,
        hennaOne: string,
        barBatOne: string,
        genericOne: string
      ) =>
        `Que ce soit un ${weddingOne}, un ${hennaOne}, une ${barBatOne} ou tout autre ${genericOne} — j’adapte la musique à votre public et à l’ambiance souhaitée. Grâce à un timing précis, une excellente lecture du public et une fusion intelligente des styles, la soirée se déroule naturellement avec une énergie élevée et une piste pleine`,

      section5SubtitleMobile: (
        weddingMany: string,
        hennaMany: string,
        barBatOne: string,
        genericMany: string,
        genericOne: string
      ) =>
        `${weddingMany}, ${hennaMany}, ${barBatOne} et événements professionnels — j’adapte la musique à votre public et garde la piste pleine jusqu’à la fin de ${genericOne}.`,

      section6Title: (brandTitle: string) =>
        `Avis sur ${brandTitle}`,

      section6Subtitle: (genericOne: string) =>
        `Que disent les clients de l’expérience sur la piste de danse ? Avis réels sur la musique, l’énergie et l’accompagnement du premier appel jusqu’à la fin de ${genericOne}`,
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 1 — OPEN
  // ─────────────────────────────────────────────────────────────

  section1: {
    targetPageLines: {
      base: [
        'Plus de 15 ans d’expérience dans tous types d’événements',
        'Musique adaptée à l’énergie de votre public',
        'Excellente lecture du public et ambiance irrésistible',
        'Piste de danse pleine jusqu’au petit matin',
      ],

      wedding: [
        'Plus de 15 ans d’expérience en mariages',
        'Musique adaptée à chaque moment du mariage',
        'Bande-son personnalisée',
        'Mix fluides et excellente lecture du public',
        'Planification musicale complète et accompagnement professionnel',
        'Un mariage dont les invités parleront longtemps',
      ],

      henna: [
        'Célébration de henné émotive avec ambiance authentique',
        'Ambiance colorée et joyeuse',
        'Mélange parfait de tradition et de modernité',
        'Rythmes qui entraînent toute la famille',
        'Playlist adaptée à votre henné',
        'Cérémonie électrisante pleine d’émotion',
      ],

      bar_bat: [
        'Plus de 15 ans d’expérience en Bar/Bat Mitsva',
        'Entrée mémorable',
        'Piste pleine du premier morceau au dernier',
        'Hits actuels pour adolescents et adultes',
        'Ambiance familiale joyeuse',
        'Expérience musicale mémorable',
      ],

      event: [
        'Plus de 15 ans d’expérience événementielle',
        'Musique précise et excellente lecture du public',
        'Son professionnel et mix fluides',
        'Ambiance énergique et festive',
        'Playlist adaptée à votre événement',
        'Une expérience musicale inoubliable',
      ],
    },

    hub: {
      city: {
        descriptionLines: (
          keyword: string,
          cityBet: string,
          brandTitle: string
        ) => [
          'Plus de 15 ans d’expérience qui parlent d’eux-mêmes',
          'Musique adaptée à chaque type de public',
          'Capacité à lire la piste et jouer le bon morceau',
          'Ambiance joyeuse du début à la fin de l’événement',
          `${brandTitle} — ${keyword}${cityBet}`,
        ],

        extraHeadings: (keyword: string, cityBet: string) => [
          `Comment choisir ${keyword}${cityBet} correctement`,
          `Types d’événements populaires${cityBet}`,
        ],
      },

      region: {
        descriptionLines: (
          keyword: string,
          regionBet: string,
          brandTitle: string
        ) => [
          'Plus de 15 ans d’expérience qui parlent d’eux-mêmes',
          'Musique variée adaptée à tous les publics',
          'Piste pleine d’énergie et de joie',
          'Ambiance festive toute la soirée',
          `${brandTitle} — ${keyword}${regionBet}`,
        ],

        extraHeadings: (keyword: string, regionBet: string) => [
          `Comment choisir ${keyword}${regionBet}`,
          `Villes principales${regionBet} pour commencer votre recherche`,
        ],
      },

      home: {
        section1Lines: (
          eventOne: string,
          mcLabel: string,
          brandTitle: string
        ) => [
          `Plus de 15 ans d’expérience pour garantir un ${eventOne} parfait`,
          'Musique précise et excellente lecture du public',
          'Son professionnel et mix fluides',
          `${eventOne} avec une ambiance joyeuse et énergique`,
          `Playlist adaptée exactement à votre ${eventOne}`,
          'Une expérience musicale inoubliable',
          `${brandTitle} — ${mcLabel} pour le ${eventOne} parfait`,
        ],
      },
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 2 — ABOUT
  // ─────────────────────────────────────────────────────────────

  section2: {
    title: 'Mon histoire',
    description:
      `Avec plus de 15 ans derrière les platines, dont une décennie en tant que DJ résident au Forum — je suis ELIOR MOR, apportant l’énergie idéale, une lecture experte du public et une musique qui maintient la piste vivante du premier au dernier morceau.`,

    additionalText:
      'Pour moi, chaque événement est une opportunité de créer des moments inoubliables. Je lis le public, mélange les styles et surprends avec des morceaux oubliés — transformant votre événement en une expérience unique',

    imageAltPortrait: `ELIOR MOR au DJ booth`,
    imageAltHorizontal: `ELIOR MOR — DJ qui sait enflammer la fête`,

    targetAdditionalByService: {
      wedding:
        'Un mariage est une histoire d’amour racontée à travers la musique. Je commence par vous connaître vraiment — qui vous êtes, ce que vous aimez et comment vous imaginez votre mariage. Ensuite, nous créons une bande-son personnalisée et construisons chaque moment ensemble',

      henna:
        'Chaque henné est une fête colorée que je construis dès le premier instant. Mon objectif est simple — ambiance joyeuse, énergie et piste pleine. Je mélange tradition et modernité pour créer une énergie irrésistible',

      bar_bat:
        'Chaque Bar/Bat Mitsva est une opportunité de créer des moments spéciaux qui rassemblent tout le monde. Mon objectif est une fête naturelle pour les jeunes et agréable pour les adultes',

      event:
        'Chaque événement est une opportunité de créer une expérience musicale précise adaptée au public et à l’occasion, avec une énergie constante toute la nuit',
    },

    targetAdditionalSuffixByService: {
      wedding:
        'J’apporte une touche personnelle et une précision ressentie à chaque moment',

      henna:
        'J’ajoute une touche unique qui transforme votre henné en fête mémorable',

      bar_bat:
        'Je construis une identité musicale adaptée à votre famille',

      event:
        'J’ajuste la musique pour donner un caractère unique à chaque événement',
    },

    fallbackSuffix:
      'Ainsi votre événement bénéficie d’une ambiance parfaitement adaptée à votre public',

    targetDescription: (
      baseDescription: string,
      djKeyword: string,
      cityBet: string
    ) =>
      `${baseDescription} Je suis ${djKeyword}${cityBet}, avec une excellente connaissance du public et des lieux locaux`,

    targetAdditionalText: (
      base: string,
      cityBet: string,
      suffix: string
    ) => `${base} ${cityBet} ${suffix}`.replace(/\s+/g, ' ').trim(),
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 3 — GALLERY
  // ─────────────────────────────────────────────────────────────

  section3: {
    title: 'Laissez les photos parler',
    fallbackText: 'Sélectionnez un album pour voir plus de détails',
    albumsError: 'Impossible de charger les albums. Veuillez réessayer plus tard.',
    filesError: 'Erreur lors du chargement des fichiers.',
    loading: 'Chargement de la galerie…',

    galleryHeadings: {
      wedding: (keyword: string, cityBet: string) => [
        `Photos de mariage${cityBet} — cérémonie, première danse et piste`,
        `Moments de mariage${cityBet} — énergie sur la piste`,
        `Couples heureux et sets explosifs — mariages${cityBet}`,
      ],

      henna: (_keyword: string, cityBet: string) => [
        `Galerie henné${cityBet} — couleurs, rythmes et énergie`,
        `Tradition et joie — célébrations de henné${cityBet}`,
        `Tambours et énergie — vrais moments de henné${cityBet}`,
      ],

      bar_bat: (_keyword: string, cityBet: string) => [
        `Bar/Bat Mitsva${cityBet} — entrée, piste et ambiance`,
        `Jeunes et familles sur la piste — Bar/Bat Mitsva${cityBet}`,
        `Moments forts — Bar/Bat Mitsva${cityBet}`,
      ],

      event: (_keyword: string, cityBet: string) => [
        `Moments d’événements${cityBet} — piste pleine`,
        `Style musical et énergie — événements${cityBet}`,
        `Galerie d’événements${cityBet} — moments inoubliables`,
      ],
    },

    albumDescriptions: {
      weddings:
        'Photos de vrais mariages — cérémonie, première danse et piste en feu',

      hennas:
        'Couleurs, tambours et énergie — hennés pleins de joie',

      barBat:
        'Moments forts de Bar/Bat Mitsva — entrée et piste pleine',

      forum:
        'Sets électrisants du club Forum à Be’er Sheva',

      articles:
        'Articles, interviews et couverture médiatique',

      recommendations:
        'Avis réels de clients après des soirées inoubliables',

      bars:
        'Sets dans des bars à travers le pays',

      flyers:
        'Collection de flyers d’événements et clubs',
    },

    albumTexts: {
      weddings:
        'Photos de vrais mariages — cérémonie, première danse et piste en feu',

      hennas:
        'Couleurs, tambours et énergie — hennés pleins de joie',

      barBat:
        'Moments forts de Bar/Bat Mitsva — entrée et piste pleine',

      forum:
        'Sets électrisants du club Forum à Be’er Sheva',

      articles:
        'Articles, interviews et couverture médiatique',

      recommendations:
        'Avis réels de clients après des soirées inoubliables',

      bars:
        'Sets dans des bars à travers le pays',

      flyers:
        'Collection de flyers d’événements et clubs',
    },
  },
  // ─────────────────────────────────────────────────────────────
  // SECTION 4 — CONTACT / CTA
  // ─────────────────────────────────────────────────────────────

  section4: {
    title: 'Améliorez votre événement',

    description:
      'Vous cherchez un DJ pour votre événement ?\nIci vous trouverez la combinaison parfaite entre expérience, énergie et musique',

    groupTitles: {
      contact: 'Contact',
      events: 'Types d’événements',
      services: 'Services supplémentaires',
    },

    eventsIntro: {
      default: `Musique adaptée à tout type d’événement, privé ou professionnel`,

      wedding: (keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `${keyword}${loc} — de la cérémonie à la soirée, une musique adaptée à vous et à vos invités`;
      },

      henna: (keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `${keyword}${loc} — rythmes traditionnels mêlés à des sons modernes pour une célébration familiale colorée`;
      },

      bar_bat: (keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `${keyword}${loc} — hits actuels et classiques intemporels que tout le monde apprécie`;
      },

      event: (_keyword: string, _cityBet: string) =>
        `Musique personnalisée pour tout type d’événement, privé ou professionnel`,
    },

    servicesIntro: {
      wedding: (_keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `Options mariage${loc} : éclairage, son professionnel et animations.`;
      },

      henna: (_keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `Options henné${loc} : percussionnistes, éclairage chaleureux et animations`;
      },

      bar_bat: (_keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `Options Bar/Bat Mitsva${loc} : éclairage, son de qualité et animations`;
      },

      event: (_keyword: string, cityBet: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return `Options événement${loc} : éclairage, son et animations adaptées`;
      },
    },

    eventsTexts: {
      wedding: (cityBet: string) =>
        `DJ mariage${cityBet} — musique parfaitement adaptée aux mariés et invités`,

      henna: (cityBet: string) =>
        `DJ henné${cityBet} — tradition authentique et rythmes modernes`,

      bar_bat: (cityBet: string) =>
        `DJ Bar/Bat Mitsva${cityBet} — hits pour toutes les générations`,

      event: (cityBet: string) =>
        `DJ événement${cityBet} — privé ou professionnel, adapté à tous les styles`,
    },

    groupTitlesSeo: {
      wedding: (keyword: string, cityBet: string, brand: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return {
          contact: `Contacter ${brand}`,
          events: `Autres types d’événements${loc}`,
          services: `Services complémentaires mariage${loc}`,
          links: `Pages liées pour ${keyword}${loc}`,
        };
      },

      henna: (keyword: string, cityBet: string, brand: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return {
          contact: `Contacter ${brand}`,
          events: `Autres événements${loc}`,
          services: `Services complémentaires henné${loc}`,
          links: `Pages liées pour ${keyword}${loc}`,
        };
      },

      bar_bat: (keyword: string, cityBet: string, brand: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return {
          contact: `Contacter ${brand}`,
          events: `Types d’événements populaires${loc}`,
          services: `Options Bar/Bat Mitsva${loc}`,
          links: `Pages liées pour ${keyword}${loc}`,
        };
      },

      event: (keyword: string, cityBet: string, brand: string) => {
        const loc = cityBet ? ` ${cityBet.trim()}` : '';
        return {
          contact: `Contacter ${brand}`,
          events: `Types d’événements couverts${loc}`,
          services: `Services complémentaires événement${loc}`,
          links: `Pages liées pour ${keyword}${loc}`,
        };
      },
    },

    contactSeo: {
      phone: `Appelez-moi — je serai ravi de répondre à vos questions.`,
      whatsapp: `Envoyez un message WhatsApp — je vous répondrai rapidement.`,
      email: `Vous pouvez aussi envoyer un email — réponse rapide.`,
      instagram: `Découvrez Instagram — vidéos et photos en direct.`,
      facebook: `Sur Facebook — avis et moments réels d’événements.`,
      navigate: `Accès facile — cliquez pour ouvrir Google Maps.`,
    },

    contactButtons: {
      phone: 'Appeler',
      whatsapp: 'WhatsApp',
      email: 'Email',
      instagram: 'Instagram',
      facebook: 'Facebook',
      navigate: 'Itinéraire',
    },

    prefills: {
      wedding:
        'Bonjour Elior,\nJe souhaiterais recevoir des informations pour un DJ de mariage.',
      henna:
        'Bonjour Elior,\nJe suis intéressé par un DJ pour un henné.',
      barBat:
        'Bonjour,\nJe cherche un DJ pour une Bar/Bat Mitsva — pouvez-vous m’envoyer des détails ?',
      generic:
        'Bonjour,\nJe recherche un DJ pour un événement privé/professionnel.',
    },

    blockCopy: {
      withCity: (
        keyword: string,
        cityName: string,
        firstName: string
      ) => ({
        description:
          `Vous cherchez ${keyword} à ${cityName} ?\nIci vous trouverez la combinaison parfaite entre expérience, énergie et musique`,

        whatsappPrefill:
          `Bonjour ${firstName}, je suis intéressé par ${keyword} à ${cityName}`,

        linksHeading:
          `Pages liées pour ${keyword} à ${cityName}`,
      }),

      withoutCity: (
        keyword: string,
        eventName: string,
        firstName: string
      ) => ({
        description:
          `Vous cherchez un DJ pour votre ${eventName} ?\nIci vous trouverez la combinaison parfaite entre expérience, énergie et musique`,

        whatsappPrefill:
          `Bonjour ${firstName}, je suis intéressé par un DJ pour mon ${eventName}`,

        linksHeading:
          `Pages liées pour DJ`,
      }),
    },

    services: {
      sound: {
        label: 'Sonorisation',
        description: 'Son professionnel — clair et puissant dans tout espace.',
      },
      light: {
        label: 'Éclairage',
        description: 'Éclairage dynamique — transforme la piste de danse.',
      },
      attractions: {
        label: 'Animations',
        description: 'Effets spéciaux — confettis, fumée lourde, ballons et plus.',
      },
      recording: {
        label: 'Enregistrement',
        description: 'Captation — première danse, discours ou moments spéciaux.',
      },
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 5 — FAQ INTRO
  // ─────────────────────────────────────────────────────────────

  section5: {
    title: 'Infos',
    linksHeading: 'Pages recommandées',
    subtitle:
      'Réponses aux questions fréquentes sur la musique, la planification et votre événement.',
    moreLink: 'Voir plus de questions',

    headingsSeo: {
      wedding: (keyword: string, cityBet: string) => [
        `Planification musicale mariage${cityBet} du premier appel à la dernière chanson.`,
        `Musique de réception élégante.`,
        `Accompagnement complet de la cérémonie.`,
        `Entrées marié/mariée et moment du verre.`,
        `Transition fluide vers la danse.`,
        `Danse lente personnalisée.`,
        `Styles musicaux adaptés à chaque moment.`,
        `${keyword}${cityBet} qui vous accompagne jusqu’à la fin.`,
        `Piste de danse pleine d’énergie.`,
      ],

      henna: (keyword: string, cityBet: string) => [
        `Planification henné${cityBet} selon les traditions.`,
        `Ambiance joyeuse et colorée.`,
        `Entrée avec tambours.`,
        `Musique traditionnelle.`,
        `Moments clés du henné.`,
        `Musique pour échanges et cercles.`,
        `Mélange tradition/moderne.`,
        `${keyword}${cityBet} avec énergie authentique.`,
      ],

      bar_bat: (keyword: string, cityBet: string) => [
        `Planification Bar/Bat Mitsva${cityBet}.`,
        `Musique d’accueil.`,
        `Entrée personnalisée.`,
        `Musique pour discours.`,
        `Sets dynamiques.`,
        `Musique équilibrée.`,
        `Moments interactifs.`,
        `${keyword}${cityBet} qui garde la piste pleine.`,
      ],

      event: (
        keyword: string,
        cityBet: string,
        hasCity: boolean
      ) => {
        if (!hasCity) {
          return [
            `Chaque événement commence par comprendre le public.`,
            `Planification musicale complète.`,
            `Transitions naturelles.`,
            `${keyword} pour une soirée mémorable.`,
          ];
        }

        return [
          `Planification événement${cityBet}.`,
          `Musique d’accueil.`,
          `Transitions vers la danse.`,
          `${keyword}${cityBet} qui accompagne toute la soirée.`,
        ];
      },
    },

    eventTypeDescription: {
      wedding: {
        mobile: (_city: string, cityBet: string) =>
          `La musique de votre mariage${cityBet} est conçue selon votre vision — de la réception à la fête.`,

        desktop: (_city: string, cityBet: string) =>
          `Je crée une bande-son personnalisée pour votre mariage${cityBet}, de la cérémonie à la fête.`,
      },

      event: {
        mobile: (_city: string, cityBet: string) =>
          `Chaque événement${cityBet} est adapté au public.`,

        desktop: (_city: string, cityBet: string) =>
          `J’adapte la musique et le son pour chaque événement${cityBet}.`,
      },

      bar_bat: {
        mobile: (_city: string, cityBet: string) =>
          `Bar/Bat Mitsva${cityBet} — hits jeunes + classiques.`,

        desktop: (_city: string, cityBet: string) =>
          `Mix parfait entre hits modernes et classiques pour ${cityBet}.`,
      },

      henna: {
        mobile: (_city: string, cityBet: string) =>
          `Henné${cityBet} — énergie, tradition et fête.`,

        desktop: (_city: string, cityBet: string) =>
          `Tradition et énergie moderne pour un henné${cityBet}.`,
      },
    },
  },

  // ─────────────────────────────────────────────────────────────
  // SECTION 6 — REVIEWS
  // ─────────────────────────────────────────────────────────────

  section6: {
    title: 'Avis & recommandations',

    subtitle:
      'Ce que disent les clients sur la piste, l’énergie et le service',

    aggregateText: 'Basé sur de vrais avis',

    readMore: 'Voir tous les avis',

    linkText: 'Vers la page complète',

    defaults: {
      title: (brandTitle: string) =>
        `Avis et recommandations pour ${brandTitle}`,

      subtitle: (
        brandShort: string,
        keyword: string,
        cityBet: string
      ) =>
        `Que disent les clients de ${brandShort} ?\nAvis réels sur ${keyword}${cityBet} — énergie, ambiance et service.`,
    },

    reviewsCount: (count: number) =>
      `Basé sur ${count} avis`,
  },

  misc: {
    professional: 'Professionnel',
    recommended: 'Recommandé',
  },

  // ─────────────────────────────────────────────────────────────
  // FOOTER
  // ─────────────────────────────────────────────────────────────

  footer: {
    copyright: (year: number) =>
      `© ${year} DJ ELIOR MOR — Tous droits réservés`,
    recommendedPages: 'Pages recommandées',
  },

  // ─────────────────────────────────────────────────────────────
  // MENU
  // ─────────────────────────────────────────────────────────────

  menu: {
    sections: [
      { id: 'home', label: 'Accueil' },
      { id: 'story', label: 'Mon histoire' },
      { id: 'gallery', label: 'Galerie' },
      { id: 'contact', label: 'Contact' },
      { id: 'info', label: 'Infos' },
      { id: 'reviews', label: 'Avis' },
    ],
  },
  // ============================================================================
// French UI Copy — SEO FAQ + GEO (1:1 translation of en.ts)
// Texte uniquement — PAS de logique, PAS d’URLs, PAS de React
// ============================================================================
  seo: {
    faq: {
      wedding: [
        {
          q: `Que comprend un service de DJ pour mariage {city} ?`,
          a: `Le service comprend une consultation personnalisée, la création d’une bande-son sur mesure, un accompagnement professionnel tout au long du processus, une excellente lecture du public, des mix précis et une fusion des styles, avec une énergie qui garantit un mariage joyeux du premier au dernier moment.`,
        },
        {
          q: `Combien coûte un DJ pour mariage {city} ?`,
          a: `{city} Les prix varient généralement entre ₪4,000–₪9,000 selon la taille, la date et l’équipement.`,
        },
        {
          q: `Comment choisir un DJ pour mariage {city} ?`,
          a: `Il est important de choisir un DJ expérimenté avec une bonne lecture du public et une connexion avec le couple. Consultez les avis, regardez des vidéos réelles et assurez-vous qu’il comprend votre style.`,
        },
        {
          q: `Un DJ {city} fournit-il aussi l’éclairage ?`,
          a: `La plupart des salles incluent un éclairage de base. Un éclairage avancé peut être ajouté selon vos besoins.`,
        },
        {
          q: `Peut-on intégrer des musiciens live ?`,
          a: `Oui — saxophoniste, violoniste, percussionniste ou autres peuvent être intégrés.`,
        },
        {
          q: `Combien de temps joue un DJ lors d’un mariage ?`,
          a: `La durée varie selon le programme — de quelques heures à illimité.`,
        },
        {
          q: `Un DJ local {city} connaît-il les lieux ?`,
          a: `Oui, dans la plupart des cas, ce qui permet une coordination fluide et une meilleure qualité sonore.`,
        },
        {
          q: `Que comprend un forfait DJ mariage {city} ?`,
          a: `Équipement professionnel et prestation complète, avec options supplémentaires.`,
        },
        {
          q: `Y a-t-il du matériel de secours ?`,
          a: `Oui, toujours.`,
        },
        {
          q: `Comment choisir la musique de cérémonie ?`,
          a: `Choix personnalisé avec le couple pour créer un moment précis et émouvant.`,
        },
        {
          q: `Quand réserver un DJ mariage {city} ?`,
          a: `Au moins 6 mois à l’avance, voire un an en haute saison.`,
        },
        {
          q: `Peut-on choisir toute la playlist ?`,
          a: `Oui — totalement personnalisable.`,
        },
        {
          q: `Quelles sont les attractions populaires ?`,
          a: `Feux froids, fumée lourde, ballons, bulles, confettis et plus.`,
        },
      ],

      henna: [
        {
          q: `Que comprend un service DJ henné {city} ?`,
          a: `Consultation, bande-son personnalisée, accompagnement et énergie pour une fête réussie.`,
        },
        {
          q: `Quels types de henné existent ?`,
          a: `Marocain, yéménite, perse, tunisien et autres.`,
        },
        {
          q: `Comment organiser l’entrée ?`,
          a: `Planifiée à l’avance avec musique et timing précis.`,
        },
        {
          q: `Combien coûte un DJ henné {city} ?`,
          a: `₪2,500–₪5,000 selon les critères.`,
        },
        {
          q: `Comment choisir un DJ henné {city} ?`,
          a: `Expérience, lecture du public et adaptation aux traditions.`,
        },
        {
          q: `Durée de prestation ?`,
          a: `Flexible.`,
        },
        {
          q: `Attractions populaires ?`,
          a: `Feux froids, percussions, éclairage, etc.`,
        },
      ],

      bar_bat: [
        {
          q: `Que comprend un DJ Bar/Bat Mitsva {city} ?`,
          a: `Consultation, bande-son personnalisée, mix précis et énergie.`,
        },
        {
          q: `Combien coûte un DJ ?`,
          a: `₪2,500–₪4,500.`,
        },
        {
          q: `Comment choisir un DJ ?`,
          a: `Expérience avec jeunes publics.`,
        },
        {
          q: `Durée ?`,
          a: `Flexible.`,
        },
        {
          q: `Playlist ?`,
          a: `Personnalisée.`,
        },
      ],

      event: [
        {
          q: `Que comprend un DJ événement {city} ?`,
          a: `Consultation, musique personnalisée et énergie.`,
        },
        {
          q: `Combien coûte un DJ événement {city} ?`,
          a: `₪2,000–₪5,000.`,
        },
        {
          q: `Comment choisir ?`,
          a: `Expérience et avis.`,
        },
        {
          q: `Durée ?`,
          a: `Flexible.`,
        },
      ],

      homeEvent: [
        {
          q: `Que comprend un DJ événement ?`,
          a: `Consultation, musique et accompagnement.`,
        },
        {
          q: `Combien ça coûte ?`,
          a: `₪2,000–₪5,000.`,
        },
        {
          q: `Quels types d’événements ?`,
          a: `Mariages, hennés, événements privés et professionnels.`,
        },
        {
          q: `Matériel fourni ?`,
          a: `Oui.`,
        },
      ],
    },
  },

  // ─────────────────────────────────────────────────────────────
  // GEO
  // ─────────────────────────────────────────────────────────────

  geo: {
    regions: {
      דרום: 'Sud',
      מרכז: 'Centre',
    },

    cities: {
      'באר שבע': "Beer-Sheva",
      'אשקלון': 'Ashkelon',
      'אשדוד': 'Ashdod',
      'קריית גת': 'Kiryat Gat',
      'אופקים': 'Ofakim',
      'נתיבות': 'Netivot',
      'שדרות': 'Sderot',
      'להבים': 'Lehavim',
      'עומר': 'Omer',
      'דימונה': 'Dimona',
      'קריית מלאכי': 'Kiryat Malakhi',
      'ערד': 'Arad',
      'ירוחם': 'Yeruham',
      'מיתר': 'Meitar',
      'אילת': 'Eilat',
      'קריית עקרון': 'Kiryat Ekron',
      'גן יבנה': 'Gan Yavne',

      'תל אביב': 'Tel Aviv',
      'רמת גן': 'Ramat Gan',
      'גבעתיים': 'Givatayim',
      'ראשון לציון': 'Rishon LeZion',
      'חולון': 'Holon',
      'בת ים': 'Bat Yam',
      'רעננה': "Ra'anana",
      'הרצליה': 'Herzliya',
      'פתח תקווה': 'Petah Tikva',
      'יבנה': 'Yavne',
      'רחובות': 'Rehovot',
      'נס ציונה': 'Ness Ziona',
      'כפר סבא': 'Kfar Saba',
      'הוד השרון': 'Hod HaSharon',
      'מודיעין': "Modi'in",
      'ראש העין': "Rosh HaAyin",
      'נתניה': 'Netanya',
      'חדרה': 'Hadera',
      'עמק חפר': 'Vallée de Hefer',
    },

    globalLabel: 'Israël',
  },
} as const;

export type FrSeoGeoPack = typeof fr;
